module.exports = __webpack_public_path__ + "static/travis-kalanick-853d905d609b278bce2b9820fba09db5.jpg";